import type React from "react";

import { useEffect, useMemo } from "react";

import { useLaunchParams } from "@telegram-apps/sdk-react";
import { Address } from "@ton/core";
import { useTonWallet } from "@tonconnect/ui-react";

import { useAuth } from "@arc/shared/api/architecton/useAuth";

export const AuthLayer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const activeWallet = useTonWallet();

  const { initDataRaw } = useLaunchParams();

  const authMutation = useAuth();

  const initTon = useMemo(() => {
    if (!activeWallet?.account.address) return undefined;

    return {
      network: "mainnet",
      address: Address.parse(activeWallet.account.address).toString({ bounceable: false }),
      publicKey: activeWallet.account.publicKey,
    };
  }, [activeWallet?.account.address, activeWallet?.account.publicKey]);

  useEffect(() => {
    authMutation.mutate({
      authType: "telegram",
      initDataRaw: import.meta.env.PROD ? initDataRaw : undefined,
      initTon,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initTon]);

  return children;
};
